<script setup lang="ts">
import SenderNamesPage from '../features/sender-names/SenderNamesPage.vue';
</script>

<template>
  <SenderNamesPage />
</template>
